<span [ngClass]="getColor()">
	@switch (direction) {
		@case ('ahead') {
			@if (state !== 'danger') {
				<i aria-hidden="true" class="fas fa-forward fa-fw"></i>
			} @else {
				<span class="fa-stack fa-1x">
					<i aria-hidden="true" class="far fa-square fa-stack-1x"></i>
					<i
						aria-hidden="true"
						class="fas fa-forward fa-stack-1x inner-icon"
					></i>
				</span>
			}
		}
		@case ('behind') {
			@if (state !== 'danger') {
				<i aria-hidden="true" class="fas fa-backward fa-fw"></i>
			} @else {
				<span class="fa-stack fa-1x">
					<i aria-hidden="true" class="far fa-square fa-stack-1x"></i>
					<i
						aria-hidden="true"
						class="fas fa-backward fa-stack-1x inner-icon"
					></i>
				</span>
			}
		}
		@case ('on track') {
			<i aria-hidden="true" class="fas fa-graduation-cap fa-fw"></i>
		}
		@default {}
	}
</span>
